/** SGD-primary money formatting with optional USD conversion. */

export const DEFAULT_USD_TO_SGD = 1.35;

export function sgdToUsd(amountSgd, rate = DEFAULT_USD_TO_SGD) {
  const n = Number(amountSgd) || 0;
  const r = Number(rate) || DEFAULT_USD_TO_SGD;
  return r > 0 ? n / r : n;
}

export function formatSgd(amount, { maximumFractionDigits = 0 } = {}) {
  const n = Number(amount) || 0;
  return new Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: "SGD",
    maximumFractionDigits,
  }).format(n);
}

export function formatUsd(amount, { maximumFractionDigits = 0 } = {}) {
  const n = Number(amount) || 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits,
  }).format(n);
}

/** Display with explicit SGD$ / US$ prefix per product copy. */
export function formatMoneyDisplay(amountSgd, currency = "SGD", rate = DEFAULT_USD_TO_SGD) {
  const n = Number(amountSgd) || 0;
  if (String(currency).toUpperCase() === "USD") {
    return `US$${sgdToUsd(n, rate).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
  }
  return `SGD$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function formatMoneyWithPeriod(amountSgd, period, currency = "SGD", rate = DEFAULT_USD_TO_SGD) {
  return `${formatMoneyDisplay(amountSgd, currency, rate)}${period ? `/${period}` : ""}`;
}
